import React from "react";
import {JobDefinitions} from "./components/job-definition/JobDefinitions";
import {PanelTab} from "./components/panel-tab/PanelTab";
import {ICustomTabWindow} from "./components/interfaces/ICustomTabWindow";
import {AllJobRuns} from "./components/job-run/AllJobRuns";

export const QueryToolHomePage = () => {
	const tabs: ICustomTabWindow[] = [
		{
			title: "Job Definitions",
			window: (<JobDefinitions />)
		},
		{
			title: "Runs",
			window: (<AllJobRuns />)
		}
	];
	
	return (
		<>
			<PanelTab tabs={tabs} />
		</>
	);
};
